/** Runtime config loaded from /config.json (SPA_RUNTIME_CONFIG). */

export interface AuthConfig {
  apiEndpoint: string;
  cognitoAuthDomain: string;
  cognitoClientId: string;
  cognitoUserPoolId: string;
  productId: string;
  userGroupName: string;
  powerUserGroupName: string;
  adminGroupName: string;
  b2bGatewayApiEndpoint: string;
}

let cached: AuthConfig | null = null;

export async function loadAuthConfig(): Promise<AuthConfig> {
  if (cached) return cached;
  try {
    const res = await fetch("/config.json");
    if (!res.ok) throw new Error(`Failed to load config: ${res.status}`);
    cached = (await res.json()) as AuthConfig;
    return cached;
  } catch (err) {
    console.error("Could not load /config.json:", err);
    // Fallback for local dev
    cached = {
      apiEndpoint: "http://localhost:3000",
      cognitoAuthDomain: "",
      cognitoClientId: "",
      cognitoUserPoolId: "",
      productId: "selerity-reporting",
      userGroupName: "selerity-reporting-user",
      powerUserGroupName: "selerity-reporting-power-user",
      adminGroupName: "selerity-reporting-admin",
      b2bGatewayApiEndpoint: "",
    };
    return cached;
  }
}

export function getConfig(): AuthConfig | null {
  return cached;
}
